import { Landing } from "components";
import TermsView from "./TermsView";

export const TermsContainer = () => {
  return (
    <Landing>
      <TermsView />
    </Landing>
  );
};
